import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import registerServiceWorker from './registerServiceWorker';
import 'typeface-roboto';
import 'material-ui-icons';
import {Provider} from 'react-redux';
import {applyMiddleware, compose, createStore} from 'redux';
import reducers from './reducers';
import reduxThunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import createHistory from 'history/createBrowserHistory';
import {routerMiddleware} from 'react-router-redux';
import {AUTHENTICATED_USER, SET_PERMISSIONS} from './containers/auth/types';
import {persistStore, autoRehydrate} from 'redux-persist';
import {MuiThemeProvider} from 'material-ui/styles';
import dotenv from 'dotenv';
import {theme} from './components/App.style';
import {
    blacklistFilterAjaxCallsNumber,
    blacklistFilterGridSettings1,
    blacklistFilterGridSettings2,
    blacklistFilterGridSettings3,
} from './components/blacklist/persist_blacklist';
import {composeWithDevTools} from 'redux-devtools-extension';
import 'react-select/dist/react-select.css';

dotenv.config();

const history = createHistory();
const routerMdl = routerMiddleware(history);

let store = null;

if (process.env.REACT_APP_ENV === 'dev') {
    store = createStore(
        reducers,
        undefined,
        composeWithDevTools(
            applyMiddleware(createDebounce(), reduxThunk, routerMdl),
            autoRehydrate()
        )
    );
} else {
    store = createStore(
        reducers,
        undefined,
        compose(
            applyMiddleware(createDebounce(), reduxThunk, routerMdl),
            autoRehydrate()
        )
    );
}

const token = localStorage.getItem('token');
if (token) {
    store.dispatch({type: AUTHENTICATED_USER });
}

const user = JSON.parse(localStorage.getItem('user'));
if (user) {
    store.dispatch({type: AUTHENTICATED_USER, payload: user});
}

const permissions = JSON.parse(localStorage.getItem('permissions'));
if (permissions) {
    store.dispatch({type: SET_PERMISSIONS, payload: permissions });
}

/* store.subscribe(() => {
   console.log('store updated', store.getState());
}); */

persistStore(store, {
    whitelist: ['grid', 'layout'],
    transforms: [
        blacklistFilterAjaxCallsNumber,
        blacklistFilterGridSettings1,
        blacklistFilterGridSettings2,
        blacklistFilterGridSettings3,
    ]
}, () => {
    ReactDOM.render(
        <MuiThemeProvider theme={theme}>
            <Provider store={store}>
                <App history={history} />
            </Provider>
        </MuiThemeProvider>
        , document.querySelector('#root')
    );
});

// ReactDOM.render(
//     <MuiThemeProvider theme={theme}>
//         <Provider store={store}>
//             <App history={history} />
//         </Provider>
//     </MuiThemeProvider>
//     , document.querySelector('#root')
// );

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js